import PropTypes from 'prop-types';

const CameraIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="M30.506 5c2.969 0 5.376 2.773 5.376 6.193v5.092l9.009-4.383c1.711-1.13 3.109-.201 3.109 2.075v20.057c0 2.265-1.402 3.194-3.11 2.064l-9.008-4.383v5.092c0 3.42-2.407 6.193-5.376 6.193H5.376C2.406 43 0 40.227 0 36.807V11.193C0 7.773 2.407 5 5.376 5zm-3.412 13.03a1.398 1.398 0 0 0-1.948.066 1.638 1.638 0 0 0-.038 2.192l1.983 2.153H11.309l1.983-2.153a1.638 1.638 0 0 0-.038-2.192c-.598-.598-1.496-.558-2.057.04l-4.376 4.783a1.587 1.587 0 0 0 0 2.153l4.376 4.783c.3.319.673.478 1.047.478.374 0 .71-.16 1.01-.438a1.6 1.6 0 0 0 .038-2.193l-1.983-2.152h15.782l-1.983 2.152-.098.117c-.46.604-.425 1.515.136 2.076.3.279.636.438 1.01.438s.748-.16 1.047-.478l4.376-4.783.099-.117c.46-.6.427-1.475-.099-2.036l-4.376-4.783z"
          fill={fill}
          fillRule="nonzero"
        />
      </g>
    </svg>
  </div>
);

CameraIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CameraIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CameraIcon;
